import React from "react";
import { MDBDropdownMenu, MDBDropdown, MDBDropdownToggle, MDBDropdownItem } from 'mdbreact';
import {
    obtenerFechaLocalObjeto, construirFecha, convertirAMesACodigo, convertirCodigoAMeses, obtenerToken,
    traducirPagina, obtenerUsuario

} from "../librerias/funciones"

import {
    ArrowUpOutlined,
    ArrowDownOutlined,
    UpOutlined,
    DownOutlined

} from '@ant-design/icons';

import '../styles/cpAnyos.css'


export const CPAnyosPeriodo = (props) => {

    const [initFilter, setInitFilter] = React.useState({

        ANYOS: [],
        ACTIVE_MENU: 0,
        INICIAL_MES: [
            { ID: 0, DESCRIPCION: "Todos", SELECCIONADO: true },
            { ID: 1, DESCRIPCION: "Enero", SELECCIONADO: false },
            { ID: 2, DESCRIPCION: "Febrero", SELECCIONADO: false },
            { ID: 3, DESCRIPCION: "Marzo", SELECCIONADO: false },
            { ID: 4, DESCRIPCION: "Abril", SELECCIONADO: false },
            { ID: 5, DESCRIPCION: "Mayo", SELECCIONADO: false },
            { ID: 6, DESCRIPCION: "Junio", SELECCIONADO: false },
            { ID: 7, DESCRIPCION: "Julio", SELECCIONADO: false },
            { ID: 8, DESCRIPCION: "Agosto", SELECCIONADO: false },
            { ID: 9, DESCRIPCION: "Septiembre", SELECCIONADO: false },
            { ID: 10, DESCRIPCION: "Octubre", SELECCIONADO: false },
            { ID: 11, DESCRIPCION: "Noviembre", SELECCIONADO: false },
            { ID: 12, DESCRIPCION: "Diciembre", SELECCIONADO: false },
        ],
        ID_COMPONENTE: props.ID


    })



    const crearAnyos = (ANYO_MAXIMO, NUM_ANYOS, ANYO_SELECCIONADO) => {
        let ANYOS = [];

        let NUMERO = NUM_ANYOS;
        let ULTIMO_ANYO = ANYO_MAXIMO;
        console.log("DATA", ANYO_SELECCIONADO)

        if (NUMERO !== undefined && NUMERO !== null) {
            while (NUMERO > 0) {
                NUMERO = NUMERO - 1
                ANYOS.push({ ID: ULTIMO_ANYO, DESCRIPCION: ULTIMO_ANYO, SELECCIONADO: ULTIMO_ANYO === ANYO_SELECCIONADO ? true : false })

                ULTIMO_ANYO = ULTIMO_ANYO - 1

            }
        }


        initFilter.ANYOS = ANYOS
        setInitFilter({ ...initFilter })
    }

    const seleccionadoActual = (registros) => {
        let REGISTRO = registros.find((registro) => registro.SELECCIONADO)
        return REGISTRO === undefined ? { ID: null, DESCRIPCION: null } : REGISTRO
    }


    const seleccionarRegistro = (arrayOriginal, param, ID) => {
        let expresion = `arrayOriginal.${param}`
        let convertir = eval(expresion)

        convertir.map((registro) => {
            registro.SELECCIONADO = registro.ID === ID ? true : false
        })

        setInitFilter({ ...arrayOriginal })
    }



    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            const { ANYO_MAXIMO, NUM_ANYOS, ANYO_SEL } = obtenerUsuario();
            crearAnyos(ANYO_MAXIMO, NUM_ANYOS, parseInt(ANYO_SEL))

            const fecha = new Date();
            const mesActual = fecha.getMonth() + 1;
            //REDES GRUPO Y REDES EXTERNAS
            if (props.ID === 4 || props.ID === 5 || props.ID === 6) {
              

                initFilter.INICIAL_MES = initFilter.INICIAL_MES.filter((item) => item.ID > 0)
                initFilter.INICIAL_MES.map((item) => item.SELECCIONADO = item.ID === mesActual ? true : false)

            }else if(props.MES_ACTUAL !== undefined && props.MES_ACTUAL){

                initFilter.INICIAL_MES.map((item) => item.SELECCIONADO = item.ID === mesActual ? true : false)

            }
            setInitFilter({ ...initFilter })

        }
    }, [])




    return <>

        <ul className={`nested-dropdowns mantenimiento_item1 cp_drop_Anyos ${props.className}`}  style={{ gap: '10px 0px' }}>
            {props.ID !== 8 &&
                <>
                    {/*
                    <select className={"select_periodo"}>
                        {initFilter.INICIAL_MES.map((registro) =>
                            <option
                                selected={registro.SELECCIONADO}
                                key={registro.ID}
                                onClick={() => {
                                    seleccionarRegistro(initFilter, "INICIAL_MES", registro.ID)
                                    props.MES_SELECCIONADO(initFilter)
                                }}

                            >

                                {traducirPagina(registro.DESCRIPCION).toUpperCase()}
                            </option>
                        )}
                    </select>


                    <select className={"select_periodo"} >
                        {initFilter.ANYOS.map((registro, i) =>
                            <option
                                selected={registro.SELECCIONADO}
                                key={i}

                                onChange={() => {
                                    console.log("ANYO SELEC", registro.ID)
                                    seleccionarRegistro(initFilter, "ANYOS", registro.ID)
                                    props.ANYO_SELECCIONADO(initFilter)
                                }}
                            >

                                {registro.DESCRIPCION}
                            </option>
                        )}
                    </select>

                    


 */}



                    <li className={initFilter.ACTIVE_MENU === 1 && "nested-dropdowns_active"}
                        onClick={() => { initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 1 ? 0 : 1; setInitFilter({ ...initFilter }) }}>
                        <div className={`nested-dropdowns__item`}  >
                            {traducirPagina(seleccionadoActual(initFilter.INICIAL_MES).DESCRIPCION).toUpperCase()}

                            {initFilter.ACTIVE_MENU === 1 ?
                                <UpOutlined></UpOutlined>
                                :
                                <DownOutlined></DownOutlined>
                            }
                        </div>

                        <ul className={initFilter.ACTIVE_MENU === 1 && "open_dropdowns"} style={props.ID === 3 || props.ID === 5 || props.ID === 9 || props.ID === 7 || props.ID === 8 ? { width: 'auto', top: '-402px' } : { width: 'auto' }}>
                            {initFilter.INICIAL_MES.map((registro) =>
                                <li key={registro.ID} onClick={() => {
                                    seleccionarRegistro(initFilter, "INICIAL_MES", registro.ID)

                                    props.MES_SELECCIONADO(initFilter)

                                }}>{traducirPagina(registro.DESCRIPCION).toUpperCase()}</li>
                            )}
                        </ul>

                    </li>

                    <li className={initFilter.ACTIVE_MENU === 2 && "nested-dropdowns_active"}
                        onClick={() => { initFilter.ACTIVE_MENU = initFilter.ACTIVE_MENU === 2 ? 0 : 2; setInitFilter({ ...initFilter }) }}
                    >
                        <div className={`nested-dropdowns__item`} >
                            {seleccionadoActual(initFilter.ANYOS).DESCRIPCION}

                            {initFilter.ACTIVE_MENU === 2 ?
                                <UpOutlined></UpOutlined>
                                :
                                <DownOutlined></DownOutlined>

                            }
                        </div>

                        <ul className={initFilter.ACTIVE_MENU === 2 && "open_dropdowns"} style={props.ID === 3 || props.ID === 5 || props.ID === 9 || props.ID === 7 || props.ID === 8 ? { top: '-185px' } : {}}>
                            {initFilter.ANYOS.map((registro, i) =>
                                <li key={i} onClick={() => {
                                    seleccionarRegistro(initFilter, "ANYOS", registro.ID)

                                    props.ANYO_SELECCIONADO(initFilter)

                                }}>{registro.DESCRIPCION}</li>
                            )}
                        </ul>
                    </li>

                </>
            }





        </ul>


    </>;
};